import { useLicenseStore } from "@/core/store/LicenseStore";
import { useAuthStore } from "@/core/store/reducers/AuthSlice";
import { Navigate } from "react-router-dom";

interface Props {
  children: JSX.Element;
  requiredRole?: "ADMIN";
  requireValidLicense?: boolean;
}

export default function ProtectedRoute({
  children,
  requiredRole,
  requireValidLicense,
}: Props) {
  const { role, token } = useAuthStore();
  const { status } = useLicenseStore();

  if (!token) return <Navigate to="/auth" />;

  if (requiredRole && role !== requiredRole)
    return <Navigate to="/vacancies" />;

  if (requireValidLicense && status === "INVALID") {
    if (role === "ADMIN") return <Navigate to="/license" />;
    return <Navigate to="/auth" />;
  }

  return children;
}
